export const userInfoConstants = {
  dropdownOptions: {
    accountSettings: "Account Settings",
    resetPassword: "Reset Password",
    administration: "Administration",
    help: "Help",
    helpNumber: "For Help Call 1-844-220-2280",
  },
  buttonName: {
    signOut: "SIGN OUT",
  },
};
